/*
 * Copyright (c) Nexign, JSC, 2019.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.0.1
 * @since 1.0.1
 */

import { createAction } from '../../../../../modules/app/createAction';
import {
    WIDGET_COSTS_LOAD_CHART,
    WIDGET_COSTS_LOAD_CHART_ERROR,
    WIDGET_COSTS_LOAD_CHART_SUCCESSFUL,
    WIDGET_COSTS_REDIRECT_TO_PAYMENTS,
    WIDGET_COSTS_REDIRECT_TO_PAYMENTS_ERROR,
} from './constant/actionConstants';
import {
    IWidgetCostsLoadChartErrorPayload,
    IWidgetCostsLoadChartPayload,
    IWidgetCostsLoadChartSuccessfulPayload,
    IWidgetCostsRedirectToPaymentsPayload,
    TWidgetCostsLoadChartAction,
    TWidgetCostsLoadChartErrorAction,
    TWidgetCostsLoadChartSuccessfulAction,
    TWidgetCostsRedirectToPaymentsAction,
    TWidgetCostsRedirectToPaymentsErrorAction,
} from './types/actionsType';

/*
* -------------------------------------------
*                LOAD CHART
* -------------------------------------------
*/

export const widgetCostsLoadChart = (payload: IWidgetCostsLoadChartPayload): TWidgetCostsLoadChartAction =>
    createAction(WIDGET_COSTS_LOAD_CHART, payload);

export const widgetCostsLoadChartSuccessful =
    (payload: IWidgetCostsLoadChartSuccessfulPayload): TWidgetCostsLoadChartSuccessfulAction =>
        createAction(WIDGET_COSTS_LOAD_CHART_SUCCESSFUL, payload);

export const widgetCostsLoadChartError =
    (payload: IWidgetCostsLoadChartErrorPayload): TWidgetCostsLoadChartErrorAction =>
        createAction(WIDGET_COSTS_LOAD_CHART_ERROR, payload);

/*
* -------------------------------------------
*       REDIRECT TO PAYMENTS BASKET
* -------------------------------------------
*/

export const widgetCostsRedirectToPayments =
    (payload: IWidgetCostsRedirectToPaymentsPayload): TWidgetCostsRedirectToPaymentsAction =>
        createAction(WIDGET_COSTS_REDIRECT_TO_PAYMENTS, payload);

export const widgetCostsRedirectToPaymentsError = (payload: string): TWidgetCostsRedirectToPaymentsErrorAction =>
    createAction(WIDGET_COSTS_REDIRECT_TO_PAYMENTS_ERROR, payload);

export type TWidgetCostsActions =
    TWidgetCostsLoadChartAction
    | TWidgetCostsLoadChartErrorAction
    | TWidgetCostsLoadChartSuccessfulAction
    | TWidgetCostsRedirectToPaymentsAction
    | TWidgetCostsRedirectToPaymentsErrorAction
;
